import { connect } from "react-redux";
import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import Modal from "../../../utils/customModal";
import * as instanceActions from "../../../../Redux/api";
import * as ClientActions from "../../../../Redux/actions/clientActions";
import { getClient, getAccounts } from "../../../../Redux/reducer/clients";
import * as CreditLineActions from "../../../../Redux/actions/credit-line";
import { errorContainer, loadingHtml, sucessInfoModal } from "../../../utils/functions";

import CompanyForm from "../../../shared/customer/companyForm";

export class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: {
        show: false,
        modalContent: null,
        onClose: undefined,
        showOnClose: false
      },
      contentReady: false
    };
  }

  componentDidMount() {
    const { modal } = this.state;
    const { match: { params }, actions: { getCreditLineByCif } } = this.props;

    modal.show = true;
    modal.modalContent = loadingHtml();

    this.setState({ modal: modal });

    return getCreditLineByCif(params.clientId, params.countryCode).then((facilities) => {
      if (facilities.length <= 0) {
        modal.modalContent = errorContainer(
          '¡Atención!',
          'El cliente no tiene una facility asignada',
          { cancelBtn: { action: () => this.closeModal(true), text: 'Cerrar' } }
        );
        this.setState({ modal: modal });
      }  else {
        this.getAccounts();
      }
      this.setState({ contentReady: true, modal: { show: false, modalContent: null, onClose: undefined } });
    }).catch((err) => {
      var title = '', message = '';
      switch (err.response.status) {
        case 404: title = '¡Error!';
          message = `El cliente con el cif ${params.clientId} no posee facilities`;
          break;
        default: title = '¡Error!';
          message = `Ocurrió un error a la hora de buscar las facilities del cliente con el cif ${params.clientId}`;
          break;
      }

      modal.show = true;
      modal.modalContent = errorContainer(
        title,
        message,
        { cancelBtn: { action: () => this.closeModal(true), text: 'Cerrar' } }
      );

      this.setState({ modal: modal });
    });
  }

  componentWillUnmount() {
    this.props.clientActions.clearClientAccounts();
  }

  getAccounts() {
    const { match: { params }, clientActions: { getClientAccounts } } = this.props;
    return getClientAccounts(params.clientId, params.countryCode);
  }

  closeModal(redirect = false) {
    this.setState({
      modal: {
        show: false,
        modalContent: null,
        onClose: undefined,
        showOnClose: false
      }
    });
    if (redirect) {
      this.props.history.push(`/bscadministrator/clients/add`);
    }
  }

  saveClient = (company) => {
    const { modal } = this.state;
    const { instance: { instanceAction } } = this.props;

    modal.show = true;
    modal.modalContent = loadingHtml();

    this.setState({ modal: modal });

    const createUrl = "/companies";

    return instanceAction(createUrl, "post", company)
      .then((response) => {
        var buttons = { formBtn: { text: 'Aceptar', action: () => this.props.history.push(`/bscadministrator/edit/${response.data.data.company.id}`) } }
        this.setState({
          modal: {
            show: true,
            modalContent: sucessInfoModal('Registro de clientes', "¡Su registro ha sido realizado con éxito!", buttons),
            onClose: () => this.props.history.push(`/bscadministrator/edit/${response.data.data.company.id}`),
            showOnClose: false
          }
        });
      })
      .catch((err) => {
        var buttons = { formBtn: { text: 'Aceptar', action: () => this.closeModal(false) } }
        if ( err.response !== undefined && Array.isArray(err.response.data.notifications) ) {
          const notification = err.response.data.notifications[0];
          this.setState({
            modal: {
              show: true,
              modalContent: sucessInfoModal(notification.message, notification.description, buttons),
              onClose: () => this.closeModal(true),
              showOnClose: false
            }
          });
        } else {
          this.setState({
            modal: {
              show: true,
              modalContent: sucessInfoModal('Error', 'Algo salió mal', buttons),
              onClose: () => this.closeModal(false),
              showOnClose: false
            }
          });
        }
      });
  };

  render() {
    const { contentReady, modal } = this.state;
    const { client, accounts,  match: { params } } = this.props;
    return (
      <div className="proof">
        {contentReady && <CompanyForm
          company={client}
          countryCode={params.countryCode}
          accounts={accounts}
          save={this.saveClient}
          method={`CREATE`}
        />}
        <Modal show={modal.show} handleClose={modal.onClose} showClose={this.state.modal.showOnClose} >{modal.modalContent}</Modal>
      </div>
    );
  }
}

export const mapState = state => {
  return {
    client: getClient(state),
    accounts: getAccounts(state)
  }
};

export const mapDispatch = (dispatch) => {
  return {
    actions: bindActionCreators(CreditLineActions, dispatch),
    clientActions: bindActionCreators(ClientActions, dispatch),
    instance: bindActionCreators(instanceActions, dispatch),
  };
};

export default withRouter(
  connect(
    mapState,
    mapDispatch
  )(Profile)
);
